import Vue from 'vue'
import Router from 'vue-router'
import AdminLayout from './layouts/AdminLayout.vue'
import LoginView from './views/LoginView.vue'
import DashboardView from './views/DashboardView.vue'
import ProductsView from './views/ProductsView.vue'
import CategoriesView from './views/CategoriesView.vue'
import CodeBatchesView from './views/CodeBatchesView.vue'
import CodesView from './views/CodesView.vue'
import ScanRecordsView from './views/ScanRecordsView.vue'
import StatisticsView from './views/StatisticsView.vue'
import ActivitiesView from './views/ActivitiesView.vue'
import UsersView from './views/UsersView.vue'
import CmsView from './views/CmsView.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/login', component: LoginView, meta: { public: true } },
    {
      path: '/',
      component: AdminLayout,
      children: [
        { path: '', redirect: '/dashboard' },
        { path: 'dashboard', component: DashboardView, meta: { title: '首页看板' } },
        { path: 'products', component: ProductsView, meta: { title: '产品管理' } },
        { path: 'categories', component: CategoriesView, meta: { title: '分类管理' } },
        { path: 'code-batches', redirect: '/codes' },
        { path: 'codes', component: CodesView, meta: { title: '防伪码管理' } },
        { path: 'scan-records', component: ScanRecordsView, meta: { title: '扫码记录' } },
        { path: 'statistics', component: StatisticsView, meta: { title: '数据统计' } },
        { path: 'activities', component: ActivitiesView, meta: { title: '活动管理' } },
        { path: 'users', component: UsersView, meta: { title: '用户管理' } },
        { path: 'cms', component: CmsView, meta: { title: '系统配置' } }
      ]
    },
    { path: '*', redirect: '/dashboard' }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('ANTI_ADMIN_TOKEN')
  if (!to.meta.public && !token) {
    next('/login')
    return
  }
  next()
})

export default router
